import type { Product, ProductOption } from './api';

export interface CartItem {
  readonly id: string;
  readonly product: Product;
  readonly quantity: number;
  readonly options: readonly { readonly option: ProductOption; readonly quantity: number }[];
  readonly removedIngredientIds: readonly string[];
  readonly notes: string;
}

export function cartItemUnitCents(item: CartItem): number {
  return (
    item.product.priceCents +
    item.options.reduce(
      (total, selected) => total + selected.option.additionalPriceCents * selected.quantity,
      0
    )
  );
}

export function cartSubtotalCents(items: readonly CartItem[]): number {
  return items.reduce((total, item) => total + cartItemUnitCents(item) * item.quantity, 0);
}

export function toCheckoutItems(items: readonly CartItem[]) {
  return items.map((item) => ({
    productId: item.product.id,
    quantity: item.quantity,
    ...(item.notes.trim() ? { notes: item.notes.trim() } : {}),
    ...(item.options.length
      ? {
          options: item.options.map((selected) => ({
            optionId: selected.option.id,
            quantity: selected.quantity
          }))
        }
      : {}),
    ...(item.removedIngredientIds.length ? { removedIngredientIds: item.removedIngredientIds } : {})
  }));
}
